import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { StatusBadge, PriorityBadge } from "@/components/common/StatusBadge";
import { format } from "date-fns";

export default function DepartmentView() {
  const { name } = useParams();
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/tasks", { params: { department: name } }).then((r) => setTasks(r.data));
    api.get("/projects", { params: { department: name } }).then((r) => setProjects(r.data));
  }, [name]);

  return (
    <div data-testid="department-view-page">
      <span className="label-caps">Department View</span>
      <h1 className="text-2xl font-display font-extrabold mt-1 mb-4">{name}</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
        <div className="card-flat p-4"><div className="text-2xl font-display font-extrabold">{tasks.length}</div><div className="text-xs text-muted-foreground">Tasks</div></div>
        <div className="card-flat p-4"><div className="text-2xl font-display font-extrabold">{tasks.filter((t) => t.status === "Completed").length}</div><div className="text-xs text-muted-foreground">Completed</div></div>
        <div className="card-flat p-4"><div className="text-2xl font-display font-extrabold text-destructive">{tasks.filter((t) => t.status === "Overdue").length}</div><div className="text-xs text-muted-foreground">Overdue</div></div>
      </div>

      <div className="card-flat p-4 mb-6">
        <span className="label-caps">Active Projects Touching {name}</span>
        <div className="mt-3 space-y-2">
          {projects.map((p) => (
            <div key={p.id} data-testid={`dept-project-row-${p.id}`} className="flex justify-between text-sm border-b border-border/50 py-2">
              <span className="font-medium">{p.name}</span><span className="text-muted-foreground">{p.completion_pct}% complete</span>
            </div>
          ))}
          {projects.length === 0 && <div className="text-sm font-mono text-muted-foreground">&gt; no projects with tasks in this department</div>}
        </div>
      </div>

      <div className="card-flat divide-y divide-border">
        {tasks.map((t) => (
          <div key={t.id} data-testid={`dept-task-row-${t.id}`} className="p-3 flex items-center justify-between">
            <div>
              <div className="text-sm font-medium">{t.title}</div>
              <div className="text-xs text-muted-foreground">{t.project_name} · {t.assignee_name || "Unassigned"} · {t.due_date ? format(new Date(t.due_date), "d MMM") : "—"}</div>
            </div>
            <div className="flex items-center gap-2"><PriorityBadge priority={t.priority} /><StatusBadge status={t.status} /></div>
          </div>
        ))}
        {tasks.length === 0 && <div className="p-4 text-sm font-mono text-muted-foreground">&gt; no tasks for this department yet</div>}
      </div>
    </div>
  );
}
